import script from "./front-cover.vue?vue&type=script&setup=true&lang=ts"
export * from "./front-cover.vue?vue&type=script&setup=true&lang=ts"

import "./front-cover.vue?vue&type=style&index=0&id=113feb29&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-113feb29"]])

export default __exports__